import Tag, {
    TAG_COLORS,
    TAG_SIZES
} from "../../../../../DesignComponents/Tag";
import { StatsTagProps } from "../types";

const StatsTag = ({ title }: StatsTagProps) => {
    return (
        <div>
            <Tag
                title={title}
                size={TAG_SIZES.Medium}
                color={TAG_COLORS.Primary}
            />
        </div>
    );
};

export default StatsTag;
